module.exports = __webpack_public_path__ + "static/media/brand-story-meaning10.c86faff6.png";